module.exports = __webpack_public_path__ + "img/code-vue-sm.2642ffd2.webp";